import React, { useState } from "react";
import axios from '../axios';
import ModalAlert from '../redux/components/modal/modal_alert';
import ModalLoader from '../modal/modal_loader';
import SectionImage from './section_image';

const Main = ({
  props,
  event,
  circle,
  company,
  expenseApplication,
  setExpenseApplication,
  expenseApplicationImages,
  setExpenseApplicationImages,
}) => {
  const modalLoaderRef = React.useRef(null);
  const modalAlertSuccessRef = React.useRef(null);
  const modalAlertDraftSuccessRef = React.useRef(null);
  const modalAlertErrorRef = React.useRef(null);
  const [isDisplayMore, setisDisplayMore] = useState(false);
  const [modalAlertError, setModalAlertError] = React.useState(
    '申請書送信に失敗しました。時間をおいてもう一度お試しください。'
  );

  const DisplayMoreToggle = () => {
    setisDisplayMore(!isDisplayMore)
  }

  const updateExpenseApplication = React.useCallback(() => {
    axios.post(`/api/community/expense_application/update/${expenseApplication.id}`, expenseApplication);
    // checkHasCredit();
  }, [expenseApplication]);

  const submitDraft = React.useCallback(() => {
    modalLoaderRef.current.openModal();
    axios
      .post(`/api/community/expense_application/draft/${expenseApplication.id}`, expenseApplication)
      .then((response) => {
        modalAlertDraftSuccessRef.current.openModal();
      })
      .catch((error) => {
        if (error.response.data) {
          setModalAlertError((prev) => error.response.data.error || prev);
        }
        modalAlertErrorRef.current.openModal();
      })
      .finally(() => {
        modalLoaderRef.current.closeModal();
      });
  }, [expenseApplication]);

  const submitPublic = React.useCallback(() => {
    modalLoaderRef.current.openModal();
    axios
      .post(`/api/community/expense_application/public/${expenseApplication.id}`, expenseApplication)
      .then((response) => {
        modalAlertSuccessRef.current.openModal();
      })
      .catch((error) => {
        if (error.response.data) {
          setModalAlertError((prev) => error.response.data.error || prev);
        }
        modalAlertErrorRef.current.openModal();
      })
      .finally(() => {
        modalLoaderRef.current.closeModal();
      });
  }, [expenseApplication]);

  const toMenuPage = React.useCallback(() => {
    modalAlertSuccessRef.current.closeModal();
    modalAlertDraftSuccessRef.current.closeModal();
    modalAlertErrorRef.current.closeModal();
    if (event.id) {
      window.location.href = '/event/' + event.id + '/event_menu';
    } else {
      window.location.href = '/my_circle/' + circle.id + '/circle_menu';
    }

  }, []);

  return (
    <div className="container col-lg-8 pt-4">
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">イベント名</p>
        <a href={`/community/${company.id_to_param}/circle/${circle.id}/events/${event.id}`} target="_blank"><p className="mb-1 text-fw-500 text-fz-14px text-black-50">{event.title}</p></a>
      </div>
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">イベント日</p>
        <p className="mb-1 text-fw-500 text-fz-14px text-black-50">{event.event_date_disp}</p>
      </div>
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">イベント参加者</p>
        <div className={event.valid_events_plans_users.length > 5 && !isDisplayMore ? "readmoreusers hide" : ""}>
          {event.valid_events_plans_users
            .map((events_plans_user, index) => {
              return (
                <a href={events_plans_user.companies_user ? `/community/${company.id_to_param}/member/${events_plans_user.companies_user.member_id}` : ""} target="_blank"><p key={index} className="mb-1 text-fw-500 text-fz-14px text-black-50">{events_plans_user.companies_user ? (company.is_real_name_required ? events_plans_user.companies_user.view_full_name_disp : events_plans_user.companies_user.nickname) : ""}</p></a>
              );
          })}
        </div>
        <div className="text-center">
          <button
            type="button"
            className="border-none bg-white text-center text-fw-bold cursor-pointer px-0 py-2"
            style={{ display: event.valid_events_plans_users.length > 5 ? "" : "none" , color: "#436BB9"}}
            value="click"
            onClick={DisplayMoreToggle}
          >
            {isDisplayMore ? "閉じる" : "さらに表示"} 
          </button>
        </div>
      </div>
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">請求金額</p>
        <input
          id="price"
          className="form-control form-control-lg"
          type="number"
          min="0"
          value={expenseApplication.amount}
          onBlur={updateExpenseApplication}
          onChange={(e) => {
            setExpenseApplication({
              ...expenseApplication,
              amount: Number(e.target.value),
            });
          }}
        />
      </div>
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">内訳</p>
        <textarea
          id="body"
          className="form-control form-control-lg"
          value={expenseApplication.breakdown}
          onBlur={updateExpenseApplication}
          placeholder={'例) 体育館利用代: 500円'}
          onChange={(e) => {
            setExpenseApplication({
            ...expenseApplication,
            breakdown: e.target.value,
            });
          }}
        />
      </div>
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">議事録</p>
        <textarea
          id="body"
          className="form-control form-control-lg"
          value={expenseApplication.description}
          onBlur={updateExpenseApplication}
          placeholder={'例) サークルメンバーとバドミントンを２時間ほど行いました。'}
          onChange={(e) => {
            setExpenseApplication({
            ...expenseApplication,
            description: e.target.value,
            });
          }}
        />
      </div>
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">添付ファイル</p>
        <SectionImage
          setExpenseApplicationImages={setExpenseApplicationImages}
          expenseApplicationImages={expenseApplicationImages}
          expenseApplication={expenseApplication}
          images={
            expenseApplicationImages
              .filter(
                (expenseApplicationImage) =>
                  expenseApplicationImage.image_url_medium
              )
              .slice(0, 10) || []
          }
        />
      </div>
      <div className="d-flex mt-4 pb-4 justify-content-center">
        <div className="mr-4" style={{ width: '35%'}}>
          <div className="">
            <button
              type="button"
              className="my-4 w-100 p-2 text-fw-bold button-color-freemium"
              style={{ maxWidth: '400px' }}
              value="submit_button_for_expense_application"
              onClick={submitDraft}
            >
              下書きを作成
            </button>
          </div>
        </div>
        <div className="ml-4" style={{ width: '35%'}}>
          <div>
            <button
              type="button"
              className="my-4 w-100 p-2 text-fw-bold button-color-freemium"
              style={{ maxWidth: '400px' }}
              value="submit_button_for_expense_application"
              onClick={submitPublic}
            >
              申請書を送信
            </button>
          </div>
        </div>
      </div>

      <ModalAlert
        ref={modalAlertSuccessRef}
        id="modalAlertSuccess"
        title="申請書送信完了"
        content="申請書を送信しました。"
        approveFunc={() => {
          toMenuPage();
        }}
      />
      <ModalAlert
        ref={modalAlertDraftSuccessRef}
        id="modalAlertDraftSuccess"
        title="下書き申請書作成完了"
        content="下書き申請書を作成しました。"
        approveFunc={() => toMenuPage()}
      />
      <ModalAlert
        ref={modalAlertErrorRef}
        id="modalAlertError"
        title="申請書送信失敗"
        content={modalAlertError}
        approveFunc={() =>
          setTimeout(
            () =>
              setModalAlertError(
                '申請書送信に失敗しました。時間をおいてもう一度お試しください。'
              ),
            1000
          )
        }
      />
      <ModalLoader ref={modalLoaderRef} />
    </div>
  );
};

export default Main;
